import { Button, Grid, Typography } from "@mui/material";
import AddSharpIcon from "@mui/icons-material/AddSharp";
import { Question } from "components/Admin/Organizations/types/Module.type";
import AcxErrorMessage from "components/UI/AcxErrorMessage";
import {
    QuestionDependencyCondition,
    QuestionDependencyQuestionAnswerCondition,
    QuestionDependencyQuestionAnswerOperator,
    QuestionDependencyType,
} from "models/Question";
import React from "react";
import { FormFieldErrors } from "shared/types/FormErrors.type";
import OrganizationModuleQuestionDependency from "./OrganizationModuleQuestionDependency";
import theme from "Theme/AppTheme";

export const emptyGUID = "00000000-0000-0000-0000-000000000000";

type Props = {
    value: Question;
    onChange: (key: keyof Question, val: any) => void;
    index: number;
    placement: number[];
    dependencyQuestions: Question[];
    errors?: FormFieldErrors;
    errorPath: string;
};

const OrganizationModuleQuestionDependencies: React.FC<Props> = ({
    value,
    onChange,
    index,
    dependencyQuestions,
    errors,
    errorPath,
}) => {
    const addTopLevelDependency = () => {
        const newQuestionAnswerDependency = {
            dependsOnQuestionId: emptyGUID,
            op: QuestionDependencyQuestionAnswerOperator.Contains,
            value: "",
            type: QuestionDependencyType.QuestionAnswer,
        } as QuestionDependencyQuestionAnswerCondition;

        return value.dependencies
            ? {
                  conditions: [
                      ...value.dependencies.conditions,
                      newQuestionAnswerDependency,
                  ],
              }
            : {
                  conditions: [newQuestionAnswerDependency],
              };
    };

    return (
        <Grid container sx={{ paddingTop: theme.spacing(2) }}>
            <Typography variant="h2">Question Dependencies</Typography>
            {!!errors?.[`${errorPath}.Dependencies`]?.length && (
                <Grid item xs={12}>
                    <AcxErrorMessage
                        errors={errors?.[`${errorPath}.Dependencies`]}
                    />
                </Grid>
            )}
            {value.dependencies &&
                value?.dependencies?.conditions.map(
                    (
                        condition: QuestionDependencyCondition,
                        conditionIndex: number,
                    ) => {
                        return (
                            <OrganizationModuleQuestionDependency
                                key={(value.id ?? "") + conditionIndex}
                                conditionIndex={conditionIndex}
                                onChange={onChange}
                                index={index}
                                value={value}
                                condition={condition}
                                dependencyQuestions={dependencyQuestions}
                                isDefault={value.isDefault}
                            />
                        );
                    },
                )}
            <Grid
                item
                xs={12}
                sx={{ display: "flex", justifyContent: "flex-end" }}
            >
                <Button
                    onClick={() => {
                        onChange("dependencies", addTopLevelDependency());
                    }}
                    color="secondary"
                    startIcon={<AddSharpIcon />}
                    sx={{
                        textTransform: "none",
                        fontWeight: "bold",
                        marginTop: "15px",
                    }}
                    disabled={value.isDefault}
                >
                    Add Dependency
                </Button>
            </Grid>
        </Grid>
    );
};

export default OrganizationModuleQuestionDependencies;
